if ('undefined' !== typeof module) {

    module.exports = function initTooltips(){
        //  Activate the tooltips
        $('[rel="tooltip"]').tooltip();
    }

}



// WEBPACK FOOTER //
// src/assets/js/init/initTooltips.js